import {Selector} from '@ngxs/store';
import {ICompany, IDeviceManagement, ITimezone, IUser} from '@interfaces/user';
import {ViewType} from '@shared/enums/view-type.enum';
import {CompanyFeature} from '@shared/enums/company-feature.enum';
import {UserStateModel} from './user-state.model';
import {UserState} from './user.state';

export class UserSelectors {
  @Selector([UserState])
  static getUser(state: UserStateModel): IUser | null {
    return state.user;
  }

  @Selector([UserState])
  static getDeviceManagement(state: UserStateModel): IDeviceManagement {
    return state.deviceManagement;
  }

  @Selector([UserState])
  static getViewType(state: UserStateModel): ViewType | null {
    return state.viewType ?? ViewType.list;
  }

  @Selector([UserState])
  static getCompanyData(state: UserStateModel): ICompany | null {
    return state.company;
  }

  @Selector([UserState])
  static getCompanyUsers(state: UserStateModel): IUser[] {
    return state.companyUsers;
  }

  @Selector([UserState])
  static getMediaHomeDirId(state: UserStateModel): number | null {
    return state.homeFolderIds.homeMedia;
  }

  @Selector([UserState])
  static getTimezone(state: UserStateModel): ITimezone | null {
    return state.timezone;
  }

  @Selector([UserState])
  static isProofOfPlayEnabled(state: UserStateModel): boolean {
    return state.features[CompanyFeature.proofOfPlay] !== false;
  }
}
